<template lang="pug">
  .instacart-settings
    nav#instacart-menu.instacart-nav(@click="enterMenu")
      img(src="@/assets/images/carrot-white.svg" width="24" height="26")
    .instacart-menu
      button#instacart-menu-close.instacart-menu__close(@click="outMenu")
        svg(width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg")
          path(d="M12.0209 12.0208L0.7072 0.707107" stroke-linecap="round")
          path(d="M12.0208 0.707107L0.707119 12.0208" stroke-linecap="round")
        | Close
        
      ul
        li
          a(id="instacart-home-link" href="#instacart-home" @click.prevent="scrollToSection($event)") Beyond the Cart
        li
          a(id="instacart-gallery-link" href="#instacart-gallery" @click.prevent="scrollToSection($event)") Gallery
        li
          a(id="instacart-map-link" href="#instacart-map" @click.prevent="scrollToSection($event)") Map  
        li
          a(id="instacart-video-link" href="#instacart-video" @click.prevent="scrollToSection($event)") Amanda Kloots
        li
          a(id="instacart-share-link" href="#instacart-share" @click.prevent="scrollToSection($event)") Share a Clap
        li
          a(id="instacart-infographic-link" href="#instacart-infographic" @click.prevent="scrollToSection($event)") Shopper Stats
        li
          a(id="instacart-blog-link" href="https://medium.com/shopper-news/beyond-the-cart-f8dec45aedcd" target="_blank") Blog
        li
          ul.menu-socials
            li
              a(id="menu-facebook-link" href="https://www.facebook.com/Instacart" target="_blank")
                svg(viewBox="0 0 155.139 155.139")
                  path(d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184 c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452 v20.341H37.29v27.585h23.814v70.761H89.584z")
            li
              a(id="menu-twitter-link" href="https://twitter.com/instacart" target="_blank")
                svg(viewBox="0 0 24 24")
                  path(d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z")
            li
              a(id="menu-instagram-link" href="https://www.instagram.com/instacart/" target="_blank")
                svg(viewBox="0 0 24 24")
                  path(d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z")
            //li
              a(id="menu-pinterest-link" href="https://www.pinterest.com.mx/Instacart/_created/" target="_blank")
                svg(viewBox="0 0 24 24")
                  path(d="m12.326 0c-6.579.001-10.076 4.216-10.076 8.812 0 2.131 1.191 4.79 3.098 5.633.544.245.472-.054.94-1.844.037-.149.018-.278-.102-.417-2.726-3.153-.532-9.635 5.751-9.635 9.093 0 7.394 12.582 1.582 12.582-1.498 0-2.614-1.176-2.261-2.631.428-1.733 1.266-3.596 1.266-4.845 0-3.148-4.69-2.681-4.69 1.49 0 1.289.456 2.159.456 2.159s-1.509 6.096-1.789 7.235c-.474 1.928.064 5.049.111 5.318.029.148.195.195.288.073.149-.195 1.973-2.797 2.484-4.678.186-.685.949-3.465.949-3.465.503.908 1.953 1.668 3.498 1.668 4.596 0 7.918-4.04 7.918-9.053-.016-4.806-4.129-8.402-9.423-8.402z")
      a(id="instacart-menu-logo" class="powered-by" href="https://www.instacart.com/")
        img(v-lazy="imageLogo" alt="Instacar logo menú" width="200" height="43")
    .instacart-menu__backdrop(v-if="menuOpen" @click="outMenu")
    button#instacart-toTop.instacart-toTop(@click="scrollTop")
      img(v-lazy="imageTop", alt="Instacart back to top" width="16" height="34")
    .home-scroll(@click="scrollToClosestSection")
      img.bounce( v-lazy="imageScroll" alt="Instacart scroll icon" width="46" height="24")
</template>
<script>
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import isMobile from 'mobile-device-detect'
import $ from 'jquery'
import imageLogo from '@/assets/images/powered-by-home.svg'
import imageTop from '@/assets/images/back-to-top.svg'
import imageScroll from '@/assets/images/scroll-icon.svg'

gsap.registerPlugin(ScrollToPlugin)


export default {
  name: 'App',
  data: function () {
      return {
        menuOpen: false,
        menu: [],
        id: 'instacart-home',
        imageLogo: imageLogo,
        imageTop: imageTop,
        imageScroll: imageScroll
      }
  },
  components: {

  },
  created(){
  },
  mounted: function () {
    this.mappingMenu();
  },
  methods: {
    scrollTop(){
      gsap.to(window, {duration: 1, scrollTo: 0, ease: "power2"});
    },
    scrollToClosestSection(){
      let next;
      if(this.id == 'instacart-gallery' || this.id == 'instacart-map'){
        next = $('#instacart-video');
      }else{
        next = $('#'+this.id).next();
      }
      setTimeout(() => {        
        gsap.to(window, {duration: 1, scrollTo: next.offset().top, ease: "power2"});
      }, 500);
    },
    scrollToSection(event){
      if(event.target.classList.contains('active')) return false;
      this.outMenu();
      if(event.target.hash == '#instacart-map'){
        this.$root.$refs.descriptions.mapView();
      } else if(event.target.hash == '#instacart-gallery') {
        this.$root.$refs.descriptions.galleryView();
      }
      setTimeout(() => {        
        gsap.to(window, {duration: 1, scrollTo: $(event.target.hash).offset().top, ease: "power2"});
      }, 600);
    },
    mappingMenu(){
      const vue = this;
      let $menuItems = $(".instacart-menu ul li a"),
      fromTop,
      cur,
      id,  
      lastId = '',
      scrollItems = $menuItems.map(function(){
        let item = $(this).attr("href");
        if (item.length && item.includes('#') && item.length > 1) { return item; }
      });
      
      $(window).on('scroll', function(){

        vue.hideScrollIcon();
        let offset_scroll = isMobile.isMobile ? 400 : 400;
        fromTop = $(this).scrollTop() + offset_scroll;
        
        cur = scrollItems.map(function(){
          if ($(this).offset().top < fromTop)
          return $(this);
        });
        cur = cur[cur.length-1];
        id = cur && cur.length ? cur[0].id : "";
        vue.id = id;
        if(lastId !== id){  
          console.log(id);  
          $('.instacart-menu ul li > a').removeClass('active');
          $('.instacart-menu ul li > a[href="#'+id+'"]').addClass('active');
          if(id == 'instacart-map' || id == 'instacart-gallery') vue.mapMenuScrolling(id);
          if(id == 'instacart-infographic') vue.$root.$refs.infophrafics.transitionNumbers()
          lastId = id; 
        }
              
      });    
                
    },
    mapMenuScrolling(id){
      console.log(id);
      $('.instacart-menu ul li > a').removeClass('active');
      //if(id == 'instacart-gallery' && $('#instacart-gallery > *').length){
      if($('#instacart-gallery > *').length){
        $('.instacart-menu ul li > a[href="#instacart-gallery"]').addClass('active');
      }else{
        $('.instacart-menu ul li > a[href="#instacart-map"]').addClass('active');
      }
      
    },
    hideScrollIcon(){
      let windowHeight = window.innerHeight;
      if(document.querySelector('footer') != null){
        let positionFromTop = document.querySelector('footer').getBoundingClientRect().top;
        let positionFromVideo = document.querySelector('#instacart-share').getBoundingClientRect().top;
        const tl = gsap.timeline();
        positionFromTop - windowHeight <= 0 ? tl.to('.home-scroll',1,{alpha: 0}) : tl.to('.home-scroll',1,{alpha: 1});
        positionFromVideo - windowHeight <= 0 ? tl.to('.instacart-toTop',0.5,{alpha: 1}) : tl.to('.instacart-toTop',0.5,{alpha: 0});
      }
    },
    enterMenu(){
      document.body.classList.add('menu-open');
      const tl = gsap.timeline()
        tl.to('.instacart-menu', 0.5, {x:0, ease: "power1.out"});
      this.menuOpen = true;
    },
    outMenu(){
      document.body.classList.remove('menu-open');
      const tl = gsap.timeline()
        tl.to('.instacart-menu', 0.5, {x:-500, ease: "power1.out"});
      this.menuOpen = false;
    }
  }
}
</script>
<style lang="scss">
body{
  &.menu-open{
    overflow: hidden;
  }
}
.instacart{
  &-toTop{
    position: fixed;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 99;
    cursor: pointer;
    background: transparent;
    border: none;
    padding: 0;
    width: 54px;
    height: 54px;
    background: rgba($green, 0.5);
    border-radius: 50%;
    overflow: hidden;
    opacity: 0;
    img{
      @include animation(backTop linear 2.5s infinite);
      transform-origin: 50% 50%;
      -webkit-transform-origin: 50% 50%;
      -moz-transform-origin: 50% 50%;
      -o-transform-origin: 50% 50%;
      -ms-transform-origin: 50% 50%;
    }
  }
  &-nav{
    position: fixed;
    width: 35px;
    height:35px;
    top: 10px;
    left: 10px;
    background: $soft_green;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10;
    @include respond-to('mobile'){
      width: 46px;
      height: 46px;
      top: 20px;
      left: 20px;
    }
    img{
      width: 18px;
      @include respond-to('mobile'){
        width: 24px;
      }
    }
  }
  &-menu{
    position: fixed;
    top: 0;
    transform: translate(-500px);
    height: 100%;
     background-color:$white;
     padding: 1rem 3rem;
      border-radius: 0;
      width: 100%;
     z-index: 20;
     display: flex;
     justify-content: center;
     align-items: center;
     flex-flow: column;
     
     @include respond-to('mobile'){
       border-radius: 0 40px 40px 0;
       width: auto;
       @include box-shadow(20px, 10px, 40px, rgba(2,65,47,0.2), false);
     }
     &__close{
       margin: 0 auto;
       display: block;
       border: none;
       background: transparent;
       text-align: center;
       color: $gray;
       font-size: 0.8rem;
       position: absolute;
       top: 1rem;
       @include respond-to('mobile'){
         top: 2rem;
       }
       @include transition(all 0.5s ease 0s);
       svg{
         display: block;
         margin: 0 auto;
         width: 15px;
         stroke: $gray;
         @include transition(all 0.5s ease 0s);
       }
       &:hover{
         color: $green;
         svg{
           stroke: $green;
           transform: rotate(720deg);
         }
       }
     }
     ul{
       margin: 0;
       padding: 0;
       display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      list-style-type: none;
      li{
        margin: 0.2rem 0;
        @include respond-to('mobile'){
          margin: 0.5rem 0;
        }
        @include respond-to('small'){
          margin: 0.75rem 0;
        }
        a{
          border: none;
          background: transparent;
          color: $gray;
          font-size: 1.5rem;
          @include transition(all 0.5s ease 0s);
          &:hover, &.active{
              color: $orange;
          }
        }
        
        ul.menu-socials{
          flex-flow: row;
          margin-top: 1rem;
          li{
            margin: 0 0.5rem;
            a{
              background: #46484C;
              padding: 5px 7px;
              border-radius: 50%;
              font-size: 1rem;
              @include transition(all 0.5s ease 0s);
              @include respond-to('mobile'){
                padding: 9px 11px;
              }
              &:hover{
                background: $orange;
                svg{
                  fill: $white;
                }
              }
              svg{
                width: 18px;
                height: 18px;
                fill: $white;
                @include transition(all 0.5s ease 0s);
              }
            }
          }
        }
      }
     }
     .powered-by{
       position: absolute;
       bottom: 0.5rem;
       width: 200px;
       @include respond-to('mobile'){
         bottom: 1.5rem;
       }
     }
     &__backdrop{
       position: fixed;
       width: 100%;
       height: 100%;
       top: 0;
       left: 0;
       cursor: pointer;
       z-index:5;
     }
  }
}

@include keyframes(backTop){
  0% {
    opacity:1;
    transform:  translate(0px,40px)  ;
  }
  50% {
    opacity:1;
    transform:  translate(0px,1px)  ;
  }
  100% {
    opacity:0;
    transform:  translate(0px,-40px)  ;
  }
}

</style>
